module.exports = __webpack_public_path__ + "img/nhanvien.5ce40fd7.svg";